// extracted by mini-css-extract-plugin
module.exports = {"responsive":"picture_responsive__QoHw7"};